export var MPXMediaType;
(function (MPXMediaType) {
    MPXMediaType["AA_ORIGINAL"] = "AA Original";
    MPXMediaType["CLIP"] = "Clip";
    MPXMediaType["EMPTY"] = "";
    MPXMediaType["FULL_EPISODE"] = "Full Episode";
    MPXMediaType["LIVE"] = "Live";
    MPXMediaType["MOVIE"] = "Movie";
    MPXMediaType["NULL"] = "NULL";
    MPXMediaType["PROMO_FULL_EPISODE"] = "Promo Full Episode";
    MPXMediaType["SEASONLESS"] = "Seasonless";
    MPXMediaType["SHOW_PROMO"] = "Show Promo";
    MPXMediaType["STANDALONE"] = "Standalone";
    MPXMediaType["TRAILER"] = "Trailer";
})(MPXMediaType || (MPXMediaType = {}));
